import { lazy } from 'react';

const RejectedCertificationConfig = {
	settings: {
		layout: {
			config: {
				footer: {
					display: false
				},
			}
		}
		
	},
	routes: [
		{
			path: '/transformer/consult/rejected-certification',
			component: lazy(() => import('./RejectedCertificationContainer'))
		}
	]
};

export default RejectedCertificationConfig;



